"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.Wrapper = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./ButtonGroup.pc.css");
const Wrapper = ({ children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_395b491b', '_3d57e58', '_pub-3d57e58') }, children));
};
exports.Wrapper = Wrapper;
const Container = ({ children }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_d7552837', '_3d57e58', '_pub-3d57e58', '_3d57e58_v3', '_pub-3d57e58_v3', 'v3') }, children));
};
exports.Container = Container;
//# sourceMappingURL=ButtonGroup.js.map